// extracted by mini-css-extract-plugin
export default {"quote":"quote__38L55"};